import ReactApexChart from 'react-apexcharts';

const DonutChart = ({ options, series, height, width }) => (
  <ReactApexChart
    options={options}
    series={series}
    type="donut"
    height={height ?? 300}
    width={width ?? 400}
  />
);

export default DonutChart;
